import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

const LoaderDisplay = () => {
    return (
        <div><CircularProgress style={{ fontSize: 40, margin: "auto" }} /></div>
    );    
};

export default LoaderDisplay;
